import axiosInstance from "../Interceptors/ResponseInterceptor";

export const getLocationByCity = async (city) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/location-master/cities/${city}`
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getLocationByCity:", error);
      reject(error);
    }
  });
};
export const getAllCities = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(`/api/location-master/cities`);
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getLocationByCity:", error);
      reject(error);
    }
  });
};
